export default {
  ThanksToTMobileBanner__ARIA_LABEL: "Thanks to T-Mobile",
  ThanksToTMobileBanner__LABEL: "Thanks to T-Mobile",
  ThanksToTMobileBanner__SUPERSCRIPT: "®",
};
